﻿import { FC, useEffect, useState } from "react";
import { AppContext } from "./AppContext";
import { Navigate, Route, Routes } from "react-router";
import { AuthenticationArea } from "./Pages/Authentication/AuthenticationArea";
import { LoadingError } from "@kaladel/react/Components";
import { HomeArea } from "./Pages/Home/HomeArea";
import { useApiClient } from "./Contexts/ApiClientContext";
import { SessionGetResponse, StaticCurrency, StatusGetResponse, ExchangeRatesGetResponse } from "ApiClient/models";

export const App: FC = () => {
    const { api, apiCall } = useApiClient();

    const [session, setSession] = useState<SessionGetResponse | null>(null);
    const [currencies, setCurrencies] = useState<StaticCurrency[] | null>(null);
    const [activeCurrency, setActiveCurrency] = useState<string | null>(null);
    const [status, setStatus] = useState<StatusGetResponse[] | null>(null);
    const [exchangeRates, setExchangeRates] = useState<ExchangeRatesGetResponse[] | null>(null);

    const refreshSession = async () => {
        setSession(null);

        const response = await apiCall(() => api.session.get());

        if (response.kind === "success") {
            setSession(response.value);
        }
    };

    const refreshCurrencies = async () => {
        const response = await apiCall(() => api.currencies.get());

        if (response.kind === "success") {
            setCurrencies(response.value);
        }
    };

    const refreshStatus = async () => {
        const response = await apiCall(() => api.status.get());

        if (response.kind === "success") {
            setStatus(response.value);
        }
    };

    const refreshExchangeRates = async () => {
        const response = await apiCall(() => api.exchangerate.get());

        if (response.kind === "success") {
            setExchangeRates(response.value);
        }
    };

    useEffect(() => {
        refreshSession();
    }, []);

    useEffect(() => {
        if (session?.id) {
            refreshCurrencies();
            refreshStatus();
            refreshExchangeRates();
        }
    }, [session]);

    return (
        <>
            <AppContext value={{ session, refreshSession, currencies, status, refreshStatus, activeCurrency, setActiveCurrency, exchangeRates, refreshExchangeRates }}>
                <LoadingError
                    value={session}
                    loaded={_session => (
                        <>
                            <Routes>
                                <Route index element={<Navigate to="/home" />} />
                                <Route path="auth">
                                    <Route index path="*" element={<AuthenticationArea />} />
                                </Route>
                                <Route path="home">
                                    <Route index path="*" element={<HomeArea />} />
                                </Route>
                            </Routes>
                        </>
                    )}
                />
            </AppContext>
        </>
    );
};
